import React from "react";

/** "● Courses ● Products ● Sessions" under a chart. `items`: `[{key, label, colorClass}]`. */
export default function ChartLegend({ items }) {
  return (
    <ul className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-eh-ink">
      {items.map((i) => (
        <li key={i.key} className="inline-flex items-center gap-1.5">
          <span aria-hidden="true" className={`inline-block h-3 w-3 rounded-full ${i.colorClass}`} />
          {i.label}
        </li>
      ))}
    </ul>
  );
}
